const context = require.context('./', true, /.*\.(gif|png|ico|svg|jpe?g)$/i);
export default context;
